<template>
	<PageContainer>
		<VCard class="d-flex flex-column pa-12">
			<p
				class="text-h4 text-md-h2 pb-3"
				style="text-align: center"
			>
				Trouver un radiologue agréé pour le dépistage organisé des cancers du sein
			</p>

			<!-- Champ de recherche -->
			<SearchSection
				@on-change-structures-list="handleChangeStructureList"
				@on-change-city="handleChangeCity"
			/>

			<!-- Liste des structures et carte -->
			<div
				v-if="structuresList.length"
				id="result-container"
				class="result-container"
			>
				<StructureList
					:structures-list="structuresList"
				/>

				<StructuresMap
					v-if="structuresList.length && city?.nom"
					:city="city"
					:structure-list="structuresList"
				/>
			</div>

			<!-- Alerte -->
			<AlertWrapper
				v-if="displayNotFoundAlert"
				outlined
				type="info"
			>
				<h2>Pas de résultat dans cette zone</h2>
			</AlertWrapper>

			<v-divider style="margin-top: 40px;" />

			<!-- Section "A retenir" -->
			<RememberSection />
		</VCard>
	</PageContainer>
</template>

<script setup lang="ts">
	import { onMounted, ref } from 'vue';
	import { VCard } from 'vuetify/lib';
	import PageContainer from '@cnamts/vue-dot/src/elements/PageContainer';

	import RememberSection from '@/features/search-radiologist/components/remember-section/remember-section.vue';
	import SearchSection from '@/features/search-radiologist/components/search-section.vue';
	import StructureList from '@/features/search-radiologist/components/result-section/structure-list.vue';
	import StructuresMap from '@/features/search-radiologist/components/map-section/structures-map.vue';
	import { Structure } from '@/types/structure';
	import { GeoApiCity } from '@/types/geo-api-city';
	import { TraceEventService } from '@/services/trace-event-service';

	const structuresList = ref<Structure[]>([]);
	const city = ref<GeoApiCity>();
	const displayNotFoundAlert = ref(false);

	/**
	 * On trace l'accès à la page de recherche
	 */
	onMounted(() => TraceEventService.trace('ACCES'));

	/**
	 * Met à jour la liste des structures
	 * @param newStructuresList Liste des structures
	 */
	function handleChangeStructureList(newStructuresList: Structure[]): void {
		displayNotFoundAlert.value = !newStructuresList.length;
		structuresList.value = newStructuresList;
	}

	/**
	 * Met à jour la ville
	 * @param newCity Ville
	 */
	function handleChangeCity(newCity: GeoApiCity): void {
		city.value = newCity;
	}
</script>

<style scoped>
.result-container {
	display: grid;
	grid-template-columns: 1fr 2fr;
	height: 800px;
	width: 90%;
	margin: auto;
}

@media screen and (max-width: 768px) {
	.result-container {
		grid-template-columns: 1fr;
		grid-template-rows: auto 2fr;
	}
}
</style>
